module.exports = __webpack_public_path__ + "img/viber.8ee59580.png";